<template>
	<div class="data-pipe-widget" :type="type" :tabindex="tabindex" @click="handleClick($event)">
		<div class="data-pipe-widget-header flex-gap-8">
			<!--@slot Used for Header Data -->
			<slot name="data-header" />
		</div>
		<div class="data-pipe-widget-stats">
			<!-- @slot Used for Stats Data -->
			<slot name="stats" />
		</div>
		<div v-if="$slots['display-data']" class="data-pipe-widget-content">
			<!-- @slot Used for Default Slots -->
			<slot name="display-data" />
		</div>
		<div class="data-pipe-widget-footer">
			<!--@slot Used for Footer Data -->
			<slot name="data-footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "DataPipeWidget",
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * defualt | 'success' | 'error' | 'warning' | 'inProgress'
		 *  */
		type: {
			type: String,
			default: "default",
			validator(value) {
				return ["default", "success", "error", "warning", "inProgress"].includes(value);
			}
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
$types: (
	"default": var(--dashboard-element-light),
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"inProgress": var(--dashboard-primary)
);
.grid-wrap-data-pipe-widget {
	// display: grid;
	// grid-gap: 12px;
	// grid-template-columns: repeat(auto-fill, 450px);
	// align-items: flex-start;

	padding: 8px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
	grid-gap: 8px;
}
div.data-pipe-widget {
	position: relative;
	overflow: hidden;
	width: 100%;
	min-width: 450px;
	// max-width: 520px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	background-color: var(--dashboard-element-light);
	border-radius: 4px;

	@each $type, $color in $types {
		&[type="#{$type}"] {
			&:not([type="default"]) {
				&:before {
					content: "";
					width: 100%;
					height: 8px;
					position: absolute;
					display: block;
					background: $color;
					border-radius: 4px 4px 0 0;
				}
			}
		}
	}

	> div.data-pipe-widget-header {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border);

		display: flex;
		align-items: center;
		.alarm-circle {
			width: 24px;
			height: 24px;
			font-size: 20px;
			margin: 0px;
			margin-right: 8px;
		}
	}
	.dw-entity-text-125 {
		max-width: 125px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	> div.data-pipe-widget-stats {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border);

		align-items: center;
		.dw-entity-wrap {
			.dw-entity-info {
				font-size: 14px;
				font-weight: normal;
			}
			.dw-entity-type {
				font-size: 12px;
			}
			.dw-entity-freq {
				font-size: 12px;
			}
		}
	}

	> div.data-pipe-widget-content {
		padding: 16px;
		.dw-entity-wrap {
			.dw-entity-head {
				white-space: normal;
			}
			.dw-entity-vlaue {
				font-size: 24px;
				font-weight: bold;
				display: block;
			}
			&.dw-entity-wrap-tb {
				min-height: 70px;
				max-width: 125px;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				.align-tp {
				}
				.align-bt {
					margin-top: auto;
				}
			}
		}
	}

	> div.data-pipe-widget-footer {
		padding: 16px;
		border-top: 1px solid var(--dashboard-border);
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.alarm-circle {
			width: 20px;
			height: 20px;
			font-size: 16px;
			margin: 0px;
			margin-right: 8px;
		}
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}

	&:focus {
		// box-shadow: 0 0 0 2px var(--dashboard-primary);
		outline: none;
	}
}
</style>
